import React from "react"

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }
  
  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
    // You can also log error messages to an error reporting service here
  }
  
  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <a href={this.props.to} {...this.props} onClick={(e) => {
          e.preventDefault();
        }}>
          {this.props.children.props.children}
        </a>
      );
    }
    // Normally, just render children
    return this.props.children;
  }  
}
